import React from 'react';
import OverlaySpinner from 'dibs-overlay-spinner';
import style from './FavNotifications-style.scss';

const FavNotificationsSpinner = () => {
    return (
        <div className={style.spinnerContainer}>
            <OverlaySpinner
                additionalWrapperClasses={style.favSpinnerWrapper}
                position={'isStatic'}
                size={'medium'}
            />
        </div>
    );
};

export default FavNotificationsSpinner;



// WEBPACK FOOTER //
// ./src/components/FavNotifications/FavNotificationsSpinner.jsx